export const PARAMETROS = {
  HABILITAR_DADOS_REAJUSTE_PINSS: 17,
  HABILITAR_SOLICITACAO_SEGUNDA_VIA: 18,
  HABILITAR_ALTERACAO_TIPO_RECEBIMENTO_BOLETO: 20,
  DISPONIBILIZAR_EXTRATO_PORMENORIZADO: 21,
  MENSAGEM_EXTRATO_PORMENORIZADO: 22,
  MENSAGEM_ANS_CARTAO_VERSO: 23,
  HABILITAR_PARCELAMENTO_FATURA: 24,
  FREQUENCIA_ATUALIZACAO_CADASTRAL: 25,
  EXIBIR_MENU_CARTA_PORTABILIDADE: 27,
  HABILITAR_FINALIDADES_ENDERECO_DEFAULT: 28
};

export const FORMACAO_PRECO_PLANO = {
  VD: 1,
  CO: 2
};

export const DOCUMENTOS = {
  RG: "00000000-0000-0000-0000-000000000002"
};

export const FINALIDADES = {
  FATURA: "00000000-0000-0000-0000-000000000001",
  CORRESPONDENCIA: "00000000-0000-0000-0000-000000000002"
};

export const LISTA_UF = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MS",
  "MT",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO"
];
export const WEB_SERVICE = ["WsA", "WsF"];

export const INFORMACOES_VERSO_CARTAO = {
  informacoes_ans: "Informações ANS",
  telefone_ouvidoria: "Telefone Ouvidoria",
  sac_telefone: "Sac/Telefone",
  valido_somente_com_apresentacao_documento_identidade:
    "Válido somente com apresentação do documento de Identidade",
  este_cartao_numerado_nominativo_intransfervel:
    "Este cartão é numerado, nominativo e intransferível"
};
